import { render, staticRenderFns } from "./wrapperObjectiveListProductions.vue?vue&type=template&id=fa3645e2&"
import script from "./wrapperObjectiveListProductions.vue?vue&type=script&lang=js&"
export * from "./wrapperObjectiveListProductions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports